module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.optionList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無配料，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger m-y-10 inline-block pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    on: {
      "click": _vm.goCrOptions
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-black m-y-10 inline-block pull-right m-r-10",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-y-10 pull-right m-r-10 ",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": _vm.copyOption
    }
  }, [_vm._v("複製配料")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-2 bg-light-gray select-element-block text-left"
  }, _vm._l((_vm.optionList), function(option, index) {
    return _c('div', {
      key: index,
      staticClass: "select-element",
      class: {
        'active': _vm.curId === option.item_id
      },
      attrs: {
        "disabled": _vm.curId === _vm.adjust.item_id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(option, index)
        }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v("\n            " + _vm._s(option.name) + "\n          ")]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("\n            " + _vm._s(option.remark) + "\n          ")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-10"
  }, [_c('div', {
    staticClass: "box-body form menu-form col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sub_type),
      expression: "optionInfo.sub_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "sub_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subTypeList), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.name),
      expression: "optionInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.optionInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.sort),
      expression: "optionInfo.sort"
    }],
    ref: "sort",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.optionInfo.sort)
    },
    on: {
      "keyup": function($event) {
        return _vm.veritySort()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.min_limit),
      expression: "optionInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "請輸入數量",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.min_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMinLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.max_limit),
      expression: "optionInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "請輸入數量",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.max_limit)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityMaxLimit()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "max_limit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price),
      expression: "optionInfo.price"
    }],
    ref: "price",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.optionInfo.price)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityPrice()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "price", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.optionInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_mandatory),
      expression: "optionInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.optionInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.remark),
      expression: "optionInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-xs-12 col-md-6 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "radio text-left h-38",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.optionInfo.is_common, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.is_common),
      expression: "optionInfo.is_common"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "commonRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.optionInfo.is_common, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.optionInfo, "is_common", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.price_type),
      expression: "optionInfo.price_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.optionInfo, "price_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("免稅價格")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("含稅價格")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("熱量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.calorie),
      expression: "optionInfo.calorie"
    }],
    ref: "calorie",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.optionInfo.calorie)
    },
    on: {
      "keyup": function($event) {
        return _vm.verityCalorie()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "calorie", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.description),
      expression: "optionInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.optionInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionInfo.vendor_custom_id),
      expression: "optionInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.optionInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.optionInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.optionInfo.adjust_id) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("分類")]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-primary btn",
    staticStyle: {
      "text-align": "left"
    },
    on: {
      "click": _vm.goAdjust
    }
  }, [_vm._v(_vm._s(_vm.optionInfo.adjust_name) + " "), _c('i', {
    staticClass: "fa fa-arrow-circle-right pull-right t-5",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.optionList.length) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.goCrOptions
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n        配料\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n                類型\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("配料名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("選購數量")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("常見價格")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("價格類型")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f246fd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrOptionTemp.vue
// module id = 2415
// module chunks = 1